import { defaultListParams, listReducer } from '../../../utils/crudUtils';
import {
  getRegistrationsAction,
  setActiveRegistrationsAction,
  searchAgenciesAction,
  createProfileAction,
  updateProfileAction,
  setRegistrationProfileAction,
} from './actions';

export const key = 'Register';

export const initialState = {
  registrationsList: defaultListParams,
  activeRegistration: {},
  searchAgencies: defaultListParams,
  regError: null,
  regProfile: null,
};

const registrationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getRegistrationsAction.TRIGGER:
    case getRegistrationsAction.SUCCESS:
      return listReducer(state, type, payload, 'registrationsList');
    case getRegistrationsAction.FAILURE:
      return { ...listReducer(state, type, payload, 'registrationsList'), activeRegistration: {} };
    case searchAgenciesAction.TRIGGER:
    case searchAgenciesAction.SUCCESS:
    case searchAgenciesAction.FAILURE:
      return listReducer(state, type, payload, 'searchAgencies');
    case createProfileAction.TRIGGER:
      return { ...state, regError: null };
    case setRegistrationProfileAction.SUCCESS:
      return { ...state, regError: null, regProfile: payload };
    case createProfileAction.SUCCESS:
    case updateProfileAction.SUCCESS:
      return { ...state, regError: null, regProfile: payload };
    case createProfileAction.FAILURE:
    case updateProfileAction.FAILURE:
      return { ...state, regError: payload };
    case setActiveRegistrationsAction.FAILURE:
      return { ...state, regError: payload };
    case setActiveRegistrationsAction.SUCCESS:
    case setActiveRegistrationsAction.TRIGGER:
      return {
        ...state,
        activeRegistration: payload,
        regError: null,
      };
    default:
      return state;
  }
};

export default registrationReducer;
